import { gameConfig } from '@root/config/game';
import { pauseSoundWhenHidden } from '@shared/phaser';
import Phaser from 'phaser';
import * as v2 from '.';
import { phaserBridge, ReactToPhaserEvent } from './bridge';

export type CreateGameParams = {
  parent: string | HTMLElement;
  width?: number;
  height?: number;
};

export function createGame({
  parent,
  width,
  height,
}: CreateGameParams): Phaser.Game {
  const scenes = [v2.Boot, v2.Preload, v2.Level];

  const finalWidth = width ?? gameConfig.canvasSize.width;
  const finalHeight = height ?? gameConfig.canvasSize.height;

  const game = new Phaser.Game({
    width: finalWidth,
    height: finalHeight,
    backgroundColor: '#14090a',
    parent,
    // GameFrame drives the size so it can render at device pixels.
    scale: {
      mode: Phaser.Scale.ScaleModes.NONE,
    },
    scene: scenes,
  });

  game.scene.start('Boot');

  const off = phaserBridge.onReactCommand((event: ReactToPhaserEvent) => {
    switch (event.type) {
      case 'FLASH': {
        const activeScenes = game.scene.getScenes(true);
        activeScenes.forEach((s) =>
          s.cameras.main.flash(event.duration ?? 250)
        );
        break;
      }
      case 'SET_BG_COLOR': {
        const activeScenes = game.scene.getScenes(true);
        activeScenes.forEach((s) =>
          s.cameras.main.setBackgroundColor(event.color)
        );
        break;
      }
      default:
        break;
    }
  });

  game.events.once(Phaser.Core.Events.DESTROY, () => off());
  // Phaser's own pause runs off blur, which phones skip.
  pauseSoundWhenHidden(game);

  return game;
}
